import Head from 'next/head';
import React from 'react';

import { renderJsonLdScript, getFaqStructuredData } from '~/libs/universal/structuredData';
import FAQ_LD from '~/components/LP/SeatingChart/Header/faqLd';
import ogImage from '../../../../../public/static-preauth/images/SeatingChartLp/hero/hero_desktop.webp';

const title = 'Wedding Seating Chart - Zola';
const description =
  'Wedding seating chart maker synced to your guest list. Group guests by diet restrictions or other custom info. Easily customize floorplans. Download and print!';

export default function Header(): JSX.Element {
  return (
    <Head>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="zola.com" />
      <meta name="twitter:site" content="@zola" />
      <meta name="twitter:card" content="summary" />
      <link rel="canonical" href="https://www.zola.com/wedding-planning/seating-chart" />
      {renderJsonLdScript(getFaqStructuredData(FAQ_LD))}
    </Head>
  );
}
